import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import _ from 'lodash';

import AuthService from './services/AuthService';
import Container from './containers/Container';
import App from './containers/App';
import Login from './containers/Login';
import Dashboard from './containers/Dashboard';
import Orders from './containers/Orders';
import Order from './containers/Orders/Edit';
import Locations from './containers/Locations';
import LLocation from './containers/Locations/Edit';
import Companies from './containers/Companies';
import Company from './containers/Companies/Edit';
import Drivers from './containers/Drivers';
import Driver from './containers/Drivers/Edit';
import Users from './containers/Users';
import User from './containers/Users/Edit';
import Label from './containers/Orders/Label';
import Dispatcher from './containers/Dispatcher';
import Inbound from './containers/Dispatcher/Inbound';
import Scan from './containers/Dispatcher/Inbound/Scan';
import Outbound from './containers/Dispatcher/Outbound';
import Manifests from './containers/Dispatcher/Manifests';
import Manifest from './containers/Dispatcher/Manifests/Edit';

import Delivered from './containers/Orders/Delivered';
import TrackItem from './containers/TrackItem';

import Trackers from './containers/Fleet/Trackers/';
import Units from './containers/Fleet/Units/';
import Trailers from './containers/Fleet/Trailers/';
import TrackerItem from './containers/Fleet/Trackers/Item';
import AddUnit from './containers/Fleet/Units/New';
import AddTrailer from './containers/Fleet/Trailers/New';
import AssignTracker from './containers/Fleet/Trackers/Assign';


const auth = new AuthService();

const requireAuth = (nextState, replace) => {
  if (!auth.loggedIn()) {
    replace({ pathname: '/login' });
  } else {
    const profile = auth.getProfile();
    const path = _.get(nextState, 'location.pathname');
    const role = _.get(profile, 'roles');
    const isAdmin = _.includes(['super-admin', 'carrier-admin', 'shipper-admin'], role);
    // need to check specific paths against specific roles
    if (path.indexOf('admin') > -1 && !isAdmin) {
      replace({ pathname: '/dashboard' });
    }
  }
}

const parseAuthHash = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.parseHash(nextState.location.hash);
  }
}

export const makeMainRoutes = () => {
  return (
    <Route path="/" component={Container} auth={auth}>
      <Route path="login" component={Login} onEnter={parseAuthHash} />

      <Route path="" component={App} onEnter={requireAuth} auth={auth}>
        <Route path="dashboard" component={Dashboard} />
        <Route path="order" component={Order} />
        <Route path="label/:tracking" component={Label} />
        <Route path="orders" component={Orders} />
        <Route path="orders/delivered" component={Delivered} />
        <Route path="order/:tracking" component={TrackItem} />
        <Route path="locations" component={Locations} />
        <Route path="location(/:locationId)" component={LLocation} />
        <Route path="fleet">
          <Route path="trackers" component={Trackers} />
          <Route path="tracker/:id" component={TrackerItem} />
          <Route path="tracker/:id/assign" component={AssignTracker} />
          <Route path="units" component={Units} />
          <Route path="unit" component={AddUnit} />
          <Route path="trailers" component={Trailers} />
          <Route path="trailer" component={AddTrailer} />
          <IndexRedirect to="/fleet/trackers" />
        </Route>
        <Route path="dispatcher">
          <Route path="dispatch" component={Dispatcher} />
          <Route path="inbound" component={Inbound} />
          <Route path="outbound" component={Outbound} />
          <Route path="manifests" component={Manifests} />
          <Route path="manifest(/:manifestId)" component={Manifest} />
          <Route path="scan" component={Scan} />
          <IndexRedirect to="/dispatcher/dispatch" />
        </Route>
        <IndexRedirect to="/dashboard" />
      </Route>
      <Route path="admin" component={App} onEnter={requireAuth} auth={auth}>
        <Route path="companies" component={Companies} />
        <Route path="company" component={Company} />
        <Route path="drivers" component={Drivers} />
        <Route path="driver" component={Driver} />
        <Route path="users" component={Users} />
        <Route path="user" component={User} />
        <IndexRedirect to="/admin/companies" />
      </Route>
      <IndexRedirect to="/dashboard" />
    </Route>
  )
}

export default makeMainRoutes;


// WEBPACK FOOTER //
// ./src/routes.js